import { resolveSurfPreviewImageUrl } from "../style/styleService.js";
/** Fetch remote image URL as data URL (CORS-safe via presigned blob fetch). */
export async function fetchUrlAsDataUrl(url) {
    let res;
    try {
        res = await fetch(url);
    }
    catch (e) {
        if (e instanceof TypeError) {
            throw new Error("Download immagine fallito (rete o CORS sul bucket S3). Verifica CORS sul bucket PDF o riprova.");
        }
        throw e;
    }
    if (!res.ok)
        throw new Error(`Fetch immagine (${res.status})`);
    const blob = await res.blob();
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(String(reader.result));
        reader.onerror = () => reject(reader.error ?? new Error("Lettura blob fallita"));
        reader.readAsDataURL(blob);
    });
}
export async function fetchS3KeyAsDataUrl(cfg, s3Key) {
    const base = cfg.presignedBaseUrl?.replace(/\/+$/, "");
    if (!base)
        throw new Error("presignedBaseUrl non configurato");
    const url = await resolveSurfPreviewImageUrl(base, cfg.getIdToken, s3Key);
    return fetchUrlAsDataUrl(url);
}
